const PageTypes = {
  HOME: 'hotels-home',
  SEARCH: 'hotels-results',
  DETAILS: 'hotels-hotel-detail',
  DEALS: 'hotels-deals',
} as const;

export default PageTypes;
